import styled from 'styled-components';

import { ColorScheme } from 'ia-react-core/~/interfaces/ColorScheme';
import media from '../../../utils/styling/media';

import COLOR_SCHEMES from '../../../constants/COLOR_SCHEMES';

export const StyledFooter = styled.footer<{
  scheme: ColorScheme;
}>`
  min-width: ${({ theme }) => theme.layout.minContentWidth}px;
  background: ${({ theme, scheme }) => {
    if (theme.layout.footerBackground) {
      return theme.layout.footerBackground;
    }

    return scheme === COLOR_SCHEMES.SHADE ? theme.colors.gray1 : theme.colors.white;
  }};
`;

export const StyledFooterContainer = styled.div`
  box-sizing: border-box;
  max-width: ${({ theme }) => theme.layout.maxFooterContentWidth || (theme.layout.maxContentWidth + 16)}px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.layout.footerPadding};

  ${media.lg`
    padding: ${({ theme }) => theme.layout.lgFooterPadding};
  `}
`;
